import { v4 as uuidv4 } from 'uuid';

export function StoreImageList(props = {}, childrenComponents = []) {
	return {
		componentName: 'StoreImageList',
		componentId: uuidv4(),
		props: Object.assign(
			{
				preload: false,
				height: 420,
				images: [],
				mzTitle: 'MZ | Lista de imagens',
			},
			props,
		),
		childrenComponents,
	};
}
